import { post } from '@dark-portal/react-infrastructure';
import { getIdentityConfig } from '../config';

export const logoutRequest = async (): Promise<void> => {
  const { request } = post({
    url: `${getIdentityConfig().apiUrl}/identity/auth/logout`,
  });

  await request;
};
